const Share = {
    open: () => Promise.resolve(),
};

export default Share;
